import React from "react";
import { useFela } from "react-fela";
import Trans from "next-translate/Trans";
import useTranslation from "next-translate/useTranslation";

import { useTheme } from "@/hooks/useTheme";

import { MagicianSection } from "@/sections/MagicianSection";
import { Card } from "@/components/Card";
import { Dropzone } from "@/components/Dropzone";
import { Heading } from "@/components/Heading";
import { BetaForm } from "@/containers/BetaForm";

import { IExtractImagesFromXDTopSection } from "./types";

type IProps = IExtractImagesFromXDTopSection;

export const ExtractImagesFromXDTopSection: React.FC<IProps> = ({
  title,
  subtitle,
  betaFormSubtitle,
}) => {
  const { css } = useFela();
  const { bp } = useTheme();

  const { t } = useTranslation("converter");

  return (
    <MagicianSection
      title={title}
      subtitle={subtitle}
      magicianLogoFile="xd"
      showStartsAt={false}
    >
      <Card
        customStyle={{
          minHeight: 380,
          maxWidth: 560,
          position: "relative",
          [bp.FROM_TABLET]: {
            minHeight: 470,
            padding: 30,
          },
          [bp.FROM_DESKTOP]: {
            marginTop: 50,
          },
        }}
      >
        <div
          className={css({
            flex: 1,
            display: "flex",
            flexDirection: "column",
          })}
        >
          <BetaForm
            title={
              <Trans
                i18nKey="converter:betaSignup.title"
                components={[<span key={0} />]}
              />
            }
            subtitle={betaFormSubtitle}
            betaType="EXTRACT_IMAGES_FROM_XD"
          />

          <Heading as="h4">{t("selectingFile.dragNDrop.title")}</Heading>

          <Dropzone disabled onDrop={() => null} />
        </div>
      </Card>
    </MagicianSection>
  );
};
